// If you don't have authentication logic applied, you can toggle requiresAuth constant to test Common UI
const requiresAuth = true;

const role = ["Admin", "User"];

export { requiresAuth, role };
